export const assetKategoriFormData = () => {
    return [
        {
            id: "asset_kategori",
            label: "Asset Kategori",
            fields: [{
                type: "input",
                placeholder: "Masukan Nama Asset Kategori"
            }]
        }
    ]
}